import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export default function ProtectedAdminRoute({ children }) {
    const [session, setSession] = useState(null);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        let isMounted = true;

        async function checkSession() {
            const { data, error } = await supabase.auth.getSession();

            if (!isMounted) return;

            if (error) {
                console.error("Session konnte nicht geprüft werden:", error);
                setSession(null);
            } else {
                setSession(data.session);
            }

            setIsChecking(false);
        }

        checkSession();

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, currentSession) => {
            setSession(currentSession);
            setIsChecking(false);
        });

        return () => {
            isMounted = false;
            subscription.unsubscribe();
        };
    }, []);

    if (isChecking) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1rem",
                    color: "#555",
                }}
            >
                Adminbereich wird geladen...
            </div>
        );
    }

    if (!session) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
}